@if (loading) {
  <div class="loading-screen-wrapper">
    <div class="loading-screen-spinner">
      <mat-progress-spinner class="mat-spinner-color" mode="indeterminate">
      </mat-progress-spinner>
    </div>
  </div>
}